import { Input, OnDestroy, Output, EventEmitter, Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { AberrationsFilter } from '../aberration-extra-details/aberration-extra-details-commons';

@Component({
    template: ''
})
export abstract class AberrationTabComponent implements OnDestroy {

  @Output() contentUpdated: EventEmitter<any> = new EventEmitter();
  @Output() noteChanged: EventEmitter<any> = new EventEmitter();

  @Input() aberration: ReplaySubject<any>;
  @Input() testTableData: any;
  @Input() currentModality: string;
  @Input() testTypeId: string;
  @Input() selections: Observable<any>;
  @Input() revisionId: string;
  @Input() firstRevisionId: string;
  @Input() configuration: any;
  @Input() currentFilter: ReplaySubject<AberrationsFilter>;

  destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
